import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

export class AreaStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      areas: [],
      routersInBuilding: [],
      routersOutOfBuilding: [],
      routerList: [],
      routerIds: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      tenantIds: null,
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.areas = [];
  }

  async setData(task, data, getAreas = true) {
    this[task] = data;
    if (getAreas) {
      this.getAreas(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async getAreas(offset = 0, limit = 0, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/routerarea`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const areas = res.body || {};
        if (areas) {
          (areas.data || []).map((val) => {
            try {
              val.routersInBuilding = val.routersInBuilding ? JSON.parse(val.routersInBuilding) : [];
              val.routersOutOfBuilding = val.routersOutOfBuilding ? JSON.parse(val.routersOutOfBuilding) : [];
            } catch (e) {
              val.routersInBuilding = [];
              val.routersOutOfBuilding = [];
            }
            val.routers = val.routersInBuilding.concat(val.routersOutOfBuilding);
            val.routerNo = val.routers.length;
            return val;
          });
        }
        return (this.areas = areas);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getAreaById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/routerarea/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let area = res.body || [];
        let routersInBuilding = [];
        let routersOutOfBuilding = [];
        let routers = [];
        let routerIds = [];
        if (area) {
          try {
            routersInBuilding = area.routersInBuilding ? JSON.parse(area.routersInBuilding) : [];
            routersOutOfBuilding = area.routersOutOfBuilding ? JSON.parse(area.routersOutOfBuilding) : [];
          } catch (e) {
            routersInBuilding = [];
            routersOutOfBuilding = [];
          }
          routers = routersInBuilding.concat(routersOutOfBuilding);
          routerIds = (routers || []).map((v) => v.id);
        }
        this.routersInBuilding = routersInBuilding;
        this.routersOutOfBuilding = routersOutOfBuilding;
        this.routerList = routers;
        this.routerIds = routerIds;

        return (this.areas = [area]);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createArea(data, routersInBuilding, routersOutOfBuilding) {
    this.loading = true;
    try {
      const detail = {
        tenantId: data.tenantId,
        name: data.name,
        userId: +localStorage.getItem('user_id'),
        routersInBuilding: JSON.stringify(routersInBuilding),
        routersOutOfBuilding: JSON.stringify(routersOutOfBuilding),
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/routerarea`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateArea(data, routersInBuilding, routersOutOfBuilding) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        userId: +localStorage.getItem('user_id'),
        routersInBuilding: JSON.stringify(routersInBuilding),
        routersOutOfBuilding: JSON.stringify(routersOutOfBuilding),
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/routerarea/${+data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteArea(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/routerarea/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new AreaStore();
